import React from 'react';

interface InventoryTicketMetricProps {
  tickets: number | string | null | undefined;
  packs: number | string | null | undefined;
  emphasized?: boolean;
  onPackClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  packTitle?: string;
  zeroPlaceholder?: React.ReactNode;
  zeroTicketPlaceholder?: React.ReactNode;
}

const toNumber = (value: number | string | null | undefined): number => {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

const InventoryTicketMetric: React.FC<InventoryTicketMetricProps> = ({
  tickets,
  packs,
  emphasized = true,
  onPackClick,
  packTitle,
  zeroPlaceholder,
  zeroTicketPlaceholder,
}) => {
  const ticketCount = toNumber(tickets);
  const packCount = toNumber(packs);
  const shouldShowPackLabel = packCount > 0;
  const packLabel = `${packCount.toLocaleString()} ${packCount === 1 ? 'pack' : 'packs'}`;
  const ticketDisplay = ticketCount === 0 && zeroTicketPlaceholder !== undefined
    ? zeroTicketPlaceholder
    : ticketCount.toLocaleString();
  if (ticketCount === 0 && packCount <= 0 && zeroPlaceholder !== undefined) {
    return (
      <div className="audit-table__inventory-metric audit-table__inventory-metric--single">
        <span className="audit-table__inventory-zero-placeholder">{zeroPlaceholder}</span>
      </div>
    );
  }

  const content = (
    <>
      <span className={`audit-table__inventory-ticket-count ${!emphasized ? 'audit-table__inventory-ticket-count--regular' : ''}`}>
        {ticketDisplay}
      </span>
      {shouldShowPackLabel ? (
        <span className="audit-table__inventory-pack-label">
          {packLabel}
        </span>
      ) : null}
    </>
  );

  if (shouldShowPackLabel && onPackClick) {
    return (
      <button
        type="button"
        className="audit-table__inventory-metric audit-table__inventory-metric--link"
        onClick={onPackClick}
        title={packTitle ?? 'Open selected packs in current inventory'}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={`audit-table__inventory-metric ${!shouldShowPackLabel ? 'audit-table__inventory-metric--single' : ''}`}>
      {content}
    </div>
  );
};

export default InventoryTicketMetric;
